export default __webpack_public_path__ + "blender.png?737f54c3ff098343264ac67df2e8cb2a";